import { render } from "./SensorValue.vue?vue&type=template&id=954dac52&scoped=true"
import script from "./SensorValue.vue?vue&type=script&lang=js"
export * from "./SensorValue.vue?vue&type=script&lang=js"

import "./SensorValue.vue?vue&type=style&index=0&id=954dac52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-954dac52"

export default script